import { SIDE_PHOTO_CONTENT_CARD_COMPONENT_NAME } from 'src/shared/static';
import { C13SidePhotoContentCardProps } from '../C13SidePhotoContentCard/C13SidePhotoContentCard.types';
import {
  SidePhotoContentCard,
  SidePhotoContentCardCarouselProps,
} from '@ahc-digital/component-library';
import { GetSidePhotoContentCardModel } from '../C13SidePhotoContentCard/C13SidePhotoContentCard.service';
import { C14SidePhotoContentCardCarouselProps } from './C14SidePhotoContentCardCarousel.types';
import { Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { parseDroplinkParam } from 'src/shared/shared.service';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export function CreateSidePhotoContentCardCarouselModel(
  props?: C14SidePhotoContentCardCarouselProps
) {
  const { renderRichText, renderLink } = useConditionalRendering();
  const { TitleType, ContentAlignment, CTAStyle, BackgroundColor, SlideTiming, SlideLayout } =
    props?.params || {};
  const { Headline, SupportCopy, BottomSupportCopy, CTA } = props?.fields || {};
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;
  const backgroundColor =
    (BackgroundColor &&
      (parseDroplinkParam(BackgroundColor)?.value
        ?.value as SidePhotoContentCardCarouselProps['backgroundColor'])) ||
    'whiteSmoke';

  const headlineTag =
    (TitleType &&
      (parseDroplinkParam(TitleType)?.value
        ?.value as SidePhotoContentCardCarouselProps['headlineTag'])) ||
    'p';

  const layout =
    (SlideLayout &&
      (parseDroplinkParam(SlideLayout)?.value
        ?.value as SidePhotoContentCardCarouselProps['layout'])) ||
    'fifty';

  const ctaStyle =
    (CTAStyle &&
      (parseDroplinkParam(CTAStyle)?.value
        ?.value as SidePhotoContentCardCarouselProps['ctaStyle'])) ||
    'solid';

  const contentAlignment =
    (ContentAlignment &&
      (parseDroplinkParam(ContentAlignment)?.value
        ?.value as SidePhotoContentCardCarouselProps['contentAlignment'])) ||
    'center';

  const slidesArray = isEditing
    ? []
    : props?.rendering?.placeholders?.['side-photo-content-cards-{*}']?.filter(
        ({ componentName }) =>
          !!componentName && componentName === SIDE_PHOTO_CONTENT_CARD_COMPONENT_NAME
      ) || [];

  const slides =
    slidesArray?.map((s, idx) => {
      const cta = s as unknown as C13SidePhotoContentCardProps;

      return (
        <SidePhotoContentCard
          key={idx}
          {...GetSidePhotoContentCardModel({
            props: cta,
            isEditing: sitecoreContext?.pageEditing || false,
          })}
          data-component={marketingRenderingName}
        />
      );
    }) || [];

  /** Only render if in Experience Editor or if NOT in Experience Editor and there's a value to display. */
  const shouldRender = (value?: string) => isEditing || (!isEditing && value);

  const carouselProps = {
    slideTimingSeconds: SlideTiming ?? '6',
    backgroundColor,
    headlineTag,
    layout,
    ctaStyle,
    contentAlignment,
    bottomSupportCopy: renderRichText(BottomSupportCopy),
    supportCopy: renderRichText(SupportCopy),
    cta: renderLink(CTA),
    headline: shouldRender(Headline?.value) ? <Text field={Headline} /> : undefined,
    slides: slides,
  } as SidePhotoContentCardCarouselProps;
  return carouselProps;
}
